import { ICreateRateioGeralUseCase } from "../../../presentation/useCases/create/create_rateio_geral_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateRateioGeralUseCase
 */

export class CreateRateioGeralUseCase implements ICreateRateioGeralUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createRateioGeral(idContasPagar: number, idsCentroCusto: number[]): Promise<void> {
    await this.repository.createRateioGeral(idContasPagar, idsCentroCusto);

  }
}
